"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));

var dom_1 = require("../utils/dom");

var useRafState_1 = __importDefault(require("./useRafState"));

function useSize(target) {
  var _a = __read(useRafState_1["default"](function () {
    var el = dom_1.getTargetElement(target);
    return {
      width: (el || {}).clientWidth,
      height: (el || {}).clientHeight
    };
  }), 2),
      state = _a[0],
      setState = _a[1];

  react_1.useLayoutEffect(function () {
    var el = dom_1.getTargetElement(target);

    if (!el) {
      return function () {};
    }

    var resizeObserver = new resize_observer_polyfill_1["default"](function (entries) {
      entries.forEach(function (entry) {
        setState({
          width: entry.target.clientWidth,
          height: entry.target.clientHeight
        });
      });
    });
    resizeObserver.observe(el);
    return function () {
      resizeObserver.disconnect();
    };
  }, [target]);
  return state;
}

exports["default"] = useSize;